import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
//
import { BlankPage } from './layouts/BlackPage';
import { PrivateRoute } from './layouts/PrivateRoute';
import Blog from './pages/Blog';
import { CKEditorComponent } from './pages/CKEditor';
import DashboardApp from './pages/DashboardApp';
import Login from './pages/Login';
import NotAuth from './pages/Page401';
import NotFound from './pages/Page404';
import Products from './pages/Products';
import User from './pages/User';
import { ViewUser } from './pages/ViewUser';
import { ROLE } from './Services/auth.service';
import Store from './pages/Store';
import BookingPage from './pages/Booking';
import Promotion from './pages/Promotion/Promotion';
import ViewPromotion from './pages/Promotion/ViewPromotion';
import { CreatePromotion } from './pages/Promotion/CreatePromotion';
import { EditPromotion } from './pages/Promotion/EditPromotion';
import Recruit from './pages/Recruit/Recruit';
import ViewRecruit from './pages/Recruit/ViewRecruit';
import { CreateRecruit } from './pages/Recruit/CreateRecruit';
import { EditRecruit } from './pages/Recruit/EditRecruit';
import Concept from './pages/Concept';
import Menu from './pages/Menu';
import MenuDetail from './pages/Menu/MenuDetail';
import Config from './pages/Config';
import LandingPage from './pages/Landing';
import EditLanding from './pages/Landing/EditLanding';
import AdsPage from './pages/Ads';
import CreateAds from './pages/Ads/CreateAds';
import EditAds from './pages/Ads/EditAds';
import BannerPage from './pages/Banner';
import CreateBanner from './pages/Banner/CreateBanner';
import ChangePassword from './pages/ChangePassword';
import NotesPage from './pages/Notes';
import CreateNote from './pages/Notes/CreateNote';
import EditNote from './pages/Notes/EditNote';
import MemberCard from './pages/MemberCard';
import CreateMemberCard from './pages/MemberCard/createMemberCard';
import MemberDetail from './pages/MemberCard/memberDetail';
import EditMemberCard from './pages/MemberCard/editMember';
import EditMemberNotes from './pages/MemberCard/editMemberNotes';
import Customer from './pages/Customer';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin, ROLE.Manager, ROLE.Recruit, ROLE.Employee, ROLE.CSKH]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [{ path: 'change-password', element: <ChangePassword /> }],
    },
    // Promotion
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin, ROLE.Manager, ROLE.Employee]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [
        {
          path: 'promotion',
          element: <Promotion />,
        },
        { path: 'promotion/create', element: <CreatePromotion /> },
        { path: 'promotion/view/:slug', element: <ViewPromotion /> },
        { path: 'promotion/edit/:slug', element: <EditPromotion /> },
      ],
    },
    // Concept
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin, ROLE.Manager]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [{ path: 'concept', element: <Concept /> }],
    },
    // Store
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin, ROLE.Manager]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [{ path: 'store', element: <Store /> }],
    },
    // Booking
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin, ROLE.Manager]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [{ path: 'booking', element: <BookingPage /> }],
    },
    // Notes
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin, ROLE.Manager, ROLE.Employee]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [
        { path: 'notes', element: <NotesPage /> },
        { path: 'notes/create', element: <CreateNote /> },
        { path: 'notes/:id', element: <EditNote /> },
      ],
    },
    // Recruit
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin, ROLE.Recruit]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [
        {
          path: 'recruit',
          element: <Recruit />,
        },
        { path: 'recruit/view/:slug', element: <ViewRecruit /> },
        { path: 'recruit/edit/:slug', element: <EditRecruit /> },
        { path: 'recruit/create', element: <CreateRecruit /> },
      ],
    },
    // User
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [
        { path: 'user', element: <User /> },
        { path: 'user/:id', element: <ViewUser /> },
      ],
    },
    // Customer
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin, ROLE.CSKH]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [{ path: 'customer', element: <Customer /> }],
    },
    // Menu
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin, ROLE.Employee]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [
        { path: 'menu', element: <Menu /> },
        { path: 'menu/:id', element: <MenuDetail /> },
      ],
    },
    // Config
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [{ path: 'config', element: <Config /> }],
    },
    // Landing
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [
        { path: 'landing', element: <LandingPage /> },
        { path: 'landing/:id', element: <EditLanding /> },
      ],
    },
    // Ctkm
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin, ROLE.Employee]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [
        { path: 'ctkm', element: <AdsPage /> },
        { path: 'ctkm/:id', element: <EditAds /> },
        { path: 'ctkm/create', element: <CreateAds /> },
      ],
    },
    // Banner
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin, ROLE.Employee]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [
        { path: 'banner', element: <BannerPage /> },
        { path: 'banner/create', element: <CreateBanner /> },
      ],
    },
    // Member
    {
      path: '/',
      element: (
        <PrivateRoute roles={[ROLE.Admin]}>
          <DashboardLayout />
        </PrivateRoute>
      ),
      children: [
        { path: 'member', element: <MemberCard /> },
        { path: 'member/create', element: <CreateMemberCard /> },
        { path: 'member/view/:id', element: <MemberDetail /> },
        { path: 'member/edit/:id', element: <EditMemberCard /> },
        { path: 'member/notes', element: <EditMemberNotes /> },
      ],
    },
    {
      path: '/',
      element: <BlankPage />,
      children: [
        { path: 'login', element: <Login /> },
        // { path: 'register', element: <Register /> },
        { path: 'ckeditor', element: <CKEditorComponent /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '/',
      element: <BlankPage />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '401', element: <NotAuth /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
